import { type ReactElement } from 'react';
import { toast, Slide } from 'react-toastify';
import './AppVersionMessage.css';

/** Toast id used by the reference stale-version toast implementation. */
export const STALE_VERSION_TOAST_ID = 'app-version-info-stale';

interface AppVersionMessageProps {
  onRefresh: () => void;
}

/**
 * Plain-text message for a stale app version. Render inline as text or in toast.
 */
export function AppVersionMessage({
  onRefresh,
}: AppVersionMessageProps): ReactElement {
  return (
    <div>
      <span>A new version of this application is available.</span>
      <button
        type="button"
        className="app-version-message-refresh"
        onClick={onRefresh}
      >
        Refresh
      </button>
    </div>
  );
}

export interface ShowStaleVersionToastOptions {
  onRefresh: () => void;
}

export function showStaleVersionToast({
  onRefresh,
}: ShowStaleVersionToastOptions): void {
  if (toast.isActive(STALE_VERSION_TOAST_ID)) {
    return;
  }

  toast(<AppVersionMessage onRefresh={onRefresh} />, {
    toastId: STALE_VERSION_TOAST_ID,
    autoClose: false,
    closeOnClick: false,
    hideProgressBar: true,
    position: 'top-center',
    transition: Slide,
    className: 'Toastify__overwrite-info',
    bodyClassName: 'Toastify__overwrite-body',
  });
}
